export function getSubdomain(): string | null {
  const host = window.location.hostname;
  const parts = host.split('.');
  // Production: rapha.aero.chat (3+ parts)
  if (parts.length >= 3) return parts[0];
  // Local dev: rapha.localhost (2 parts)
  if (parts.length === 2 && parts[1] === 'localhost') return parts[0];
  return null;
}

export function isRaphaDomain(): boolean {
  return getSubdomain() === 'rapha';
}
